import { useAuth } from './AuthProvider.js';

export function useAbility() {
  return useAuth().ability;
}
